module.exports = __webpack_public_path__ + "img/min_max.9602978d.svg";